import { render, staticRenderFns } from "./HistoricoCesionCreditos.vue?vue&type=template&id=01ea5e1a&scoped=true"
import script from "./HistoricoCesionCreditos.vue?vue&type=script&lang=js"
export * from "./HistoricoCesionCreditos.vue?vue&type=script&lang=js"
import style0 from "./HistoricoCesionCreditos.vue?vue&type=style&index=0&id=01ea5e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ea5e1a",
  null
  
)

export default component.exports